import React, { useState } from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";
import Img1 from "../../../images/landing/clutch_logo.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";
import BannerForm from "../../components/bannerfrom";

const PartnerLanding = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="partner_usa_lp p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="partner_content">
              <h2>Let’s Talk Numbers!</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              At TekRevol, we believe in quantifiable success. We're not just
              promising; we're delivering.
            </p>
            <p>
              Our track record speaks volumes. With a proven history of
              successful web development projects, we bring a wealth of
              experience to the table.
            </p>
            <Link
              to="#"
              className="lp_btn"
              aria-label="TekRevol Contact"
              onClick={handleShow}
            >
              Let’s Talk
            </Link>
          </Col>
        </Row>
        <Row className="h-100 partner_padd">
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">180+</div>
            <div className="partner-para">
              <p>Successful Projects</p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">1st</div>
            <div className="partner-para">
              <p>
                Among Top Web Developers by{" "}
                <Link to="https://clutch.co/profile/tekrevol#reviews" rel="nofollow">
                  <LazyLoadImage
                    src={Img1}
                    effect="blur"
                    alt="tekrevol_EBook"
                    className="img-fluid"
                  />
                </Link>
              </p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4.9</div>
            <div className="partner-para">
              <p>
                Average Review Rating on{" "}
                <Link to="https://clutch.co/profile/tekrevol#reviews" rel="nofollow">
                  <LazyLoadImage
                    src={Img1}
                    effect="blur"
                    alt="tekrevol_EBook"
                    className="img-fluid"
                  />
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="landing_lp_popup"
      >
        <div className="modal_forms">
          <BannerForm setShow={setShow} />
        </div>
      </Modal>
    </div>
  );
};

export default PartnerLanding;
